
import {initWebComponent} from "@/helpers/web-component-helper";
import {toggleActiveToolButton} from "@/helpers/layer-tools-helper";

export class LayerInfoToolsDrawButtonComponent extends HTMLElement {
    constructor(){
        super();

        const template = document.createElement('template');
        template.innerHTML = `<layer-info-tools-switcher-button data-title="draw" data-icon="fa fa-edit"></layer-info-tools-switcher-button>`;

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            toggleActiveToolButton(this, 'layer-info-tools-draw')
        })
    }
}

